import { Tree } from "antd";
import styled from "styled-components";

export const StyledTree = styled(Tree)`
  &.renderbus-ui--tree {
    min-width: 240px;
    background: transparent;
    .ant-tree-checkbox-checked .ant-tree-checkbox-inner {
      background-color: var(--main-color) !important;
      border-color: var(--main-color) !important;
    }
    .ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner:after {
      background-color: var(--main-color);
    }
    .ant-tree-treenode,
    .ant-tree-node-content-wrapper {
      width: 100%;
    }
    .ant-tree-checkbox-wrapper-checked:not(
        .ant-tree-checkbox-wrapper-disabled
      ):hover
      .ant-tree-checkbox-inner,
    .ant-tree-checkbox-checked:not(.ant-tree-checkbox-disabled):hover
      .ant-tree-checkbox-inner {
      background-color: var(--main-color);
    }
    .ant-tree-switcher {
      width: 10px;
      padding: 0 16px 0 12px;
      margin: auto;
    }
    .ant-tree-indent-unit {
      width: 16px;
    }
    .ant-tree-checkbox .ant-tree-checkbox-inner {
      background: transparent;
      border: 1px solid rgba(68, 80, 84, 1);
    }
    .ant-tree-checkbox + span {
      color: rgba(255, 255, 255, 0.85);
    }
    .ant-tree-checkbox {
      margin: auto 8px auto 0;
      padding-bottom: 4px;
      &:hover {
        border-color: var(--main-color) !important;
      }
    }
    .ant-tree-checkbox:not(.ant-tree-checkbox-disabled):hover
      .ant-tree-checkbox-inner {
      border-color: var(--main-color);
    }
    .ant-tree-treenode {
      padding: 0;
      margin-bottom: 4px;
    }
    .ant-tree-treenode,
    .ant-tree-title {
      min-height: 26px;
      line-height: 26px;
      &:hover {
        background: rgba(31, 31, 36, 1);
      }
    }
    .ant-tree-checkbox + span.ant-tree-node-selected {
      background: transparent;
    }
    .ant-tree-treenode-selected {
      background: rgba(31, 31, 36, 1);
      span {
        color: var(--main-color);
        font-weight: 600;
      }
    }
    .ant-tree-checkbox-disabled .ant-tree-checkbox-inner {
      background: #616d71 !important;
      border-color: #616d71 !important;
    }
  }
  &.dingtalk-init-tree {
    min-width: 220px;
    .ant-tree-list-holder-inner
      > .ant-tree-treenode:first-of-type
      .ant-tree-checkbox {
      display: none;
    }
    .ant-tree-node-content-wrapper {
      background: transparent;
      color: #ffffff;
      cursor: pointer;
    }
  }
`;
